<script lang="ts">
    import {onMount} from "svelte";
    import {user} from "../stores";

    let User = null;

    onMount(async () => {
        User = $user.getUser()
    })

</script>

{#if User}
    <div id="modal">
        <h1>
            {User.name}
            {#if User.is_admin}
                <span class="isAdmin">(admin)</span>
            {/if}
        </h1>
        <h5>
            {User.email}
        </h5>

    </div>
{/if}


<style lang="scss">
  @import "../styles/variables";

  h1 {
    color: $blue;
  }

  #modal {
    margin-top: 10px;
  }

  .isAdmin {
    font-size: 1rem;
    color: black;
  }

  .userType {
    float: right;
    color: $orange;
  }

</style>
